<template>
    <div class="default-dashboard">
        <SideBar />
        <div id="content-page">
            <div id="all-content" >
                <LogoutModal v-if="getModal" />
                <div id="header">
                    <div class="header-title">{{ $store.getters['auth/getActiveTitle']}}</div>
                    <div class="user-info">
                        <!-- <div class="offer-alerts">
                            <img src="@/assets/icons/gift.svg" alt="Obsequio" class="gift">
                            <p class="alert">2</p>
                        </div> -->
                        <Profile/>
                    </div>
                </div>
            <transition name="router-anim">
                <router-view />
            </transition>
            <Footer/>
            </div>
        </div>
    </div>
</template>

<script>
import SideBar from '@/components/SideBar'
import LogoutModal from '@/components/modals/LogoutModal'
import { mapGetters } from 'vuex'
import Profile from '@/components/Profile'
import Footer from '@/components/Footer'

export default {
    name: 'defaultLayout',
    components: {
        SideBar,
        LogoutModal,
        Profile,
        Footer
    },
    data: function(){
        return {}
    },
    computed: {
        ...mapGetters('auth', [
            'getModal'
        ])
    }
}
</script>
<style lang="sass">
body
    overflow-y: auto

.default-dashboard
    background-image: linear-gradient(135deg, #2a0681, #15032b)
    min-height: 100vh
    position: relative
    // padding-bottom: 50px
    @media (max-width: $tablet)
        padding-bottom: 124px

#content-page
    margin-left: 110px
    padding-bottom: 120px
    @include mobile
        margin-left: 0
        padding-bottom: 0
    @include mobile-landscape
        margin-left: 0
        padding-bottom: 0
    @include tablet-portrait
        margin-left: 0
        padding-bottom: 0
    @include tablet-landscape
        padding-bottom: 100px

#content-page .row
    margin-right: 0

#header
    display: grid
    grid-template-columns: 80px auto auto 8px
    grid-template-rows: 1fr
    width: 100%
    height: 80px
    @include mobile
        grid-template-columns: 8px auto auto 16px
        height: auto
    @include mobile-landscape
        grid-template-columns: 8px auto auto 16px
        height: auto
    @include tablet-landscape
        grid-template-columns: 4px auto auto 4px
    @include tablet-portrait
         grid-template-columns: 8px auto auto 4px
         height: $xl
    
    .user-info
        grid-row: 1/2
        grid-column: 2/4
        align-items: baseline
        display: flex
        flex-direction: row-reverse
        @include mobile
            


#header div
    vertical-align: top

.offer-alerts
    position: relative
    display: inline-block

.offer-alerts .gift
    width: 24px
    height: 24px
    margin-top: 28px

.offer-alerts .alert
    width: 16px
    height: 16px
    box-shadow: 0 0 4px 0 rgba(161, 166, 183, 0.45)
    border: solid 1px #ffffff
    border-radius: 50%
    background-color: #e94c2c
    font-family: Muli
    font-size: 10px
    font-weight: bold
    font-style: normal
    font-stretch: normal
    line-height: normal
    letter-spacing: normal
    text-align: right
    color: #ffffff
    text-align: center
    line-height: 16px
    position: absolute
    top: 18px
    left: 14px

.header-title
    color: #ffffff
    font-family: Montserrat
    font-size: 32px
    font-weight: 600
    padding-top: 30px
    position: relative
    grid-column: 2/3
    grid-row: 1/2
    padding-left: 8px
    @include mobile
        margin-left: 0
        width: 80%
        font-size: 26px
        padding-top: 24px
    @include mobile-landscape
        margin-left: 0
        width: 80%
        font-size: 26px
        padding-top: 24px
    @include tablet-landscape
        font-size: 24px
    @include tablet-portrait
        font-size: 24px
        padding-top: $sm
</style>
